import dayjs from 'dayjs';

export { parseTime, formatTime } from '@/util/index'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} 计算time与现在的相距时间
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * 首字母转为大写
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * 格式化时间戳（秒|毫秒）
 * @param {timestamp} value
 */
export const timeFilter = (value) => {
  if (value == undefined || value == null){
    return '-'
  }
  value = value.toString();
  if (value) {
      if (value.length === 13) {
          return dayjs(Number(value)).format("YYYY-MM-DD HH:mm:ss");
      }
      return dayjs.unix(Number(value)).format("YYYY-MM-DD HH:mm:ss");
  } else {
      return '-';
  }
}

export const timeFilterToYear = (value) => {
  value = value.toString();
  if (value) {
      if (value.length === 13) {
          return dayjs(Number(value)).format("YYYY-MM-DD");
      }
      return dayjs.unix(Number(value)).format("YYYY-MM-DD");
  } else {
      return '-';
  }
}

export const timeFilterToMin = (value) => {
  value = value.toString();
  if (value) {
      if (value.length === 13) {
          return dayjs(Number(value)).format("HH:mm:ss");
      }
      return dayjs.unix(Number(value)).format("HH:mm:ss");
  } else {
      return '-';
  }
}


/**
* 手机号格式化
* @param {String} phone
*/
export const formatPhone = (phone) => {
  phone = phone.toString();
  return phone.substr(0, 3) + '****' + phone.substr(7, 11);
};

/**
* 4位一空格（格式化银行卡）
* @param {String} val
*/
export const formatBank = (val) => {
  if (val) {
      return val.toString().replace(/\s/g, '').replace(/(.{4})/g, "$1 ");
  }
};

/**
* 千分位格式化
* @param {数字} val
*/
export const toThousands = (val) => {
  let num = (val || 0).toString(),
      result = '';
  while (num.length > 3) {
      result = ',' + num.slice(-3) + result;
      num = num.slice(0, num.length - 3);
  }
  if (num) {
      result = num + result;
  }
  return result;
}

/**
* 格式化小数位
* @param val 传入的值
* @param pos 保留的小数位
* @returns {*}
*/
export const formatFloat = (val, pos = 2) => {
  let f = parseFloat(val);
  if (isNaN(f)) {
      return false;
  }
  f = Math.round(val * Math.pow(10, pos)) / Math.pow(10, pos); // pow 幂
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
      rs = s.length;
      s += '.';
  }
  while (s.length <= rs + pos) {
      s += '0';
  }
  return s;
}

/**
* 格式化时长
* @param second
* @returns {string}
*/
export const realFormatSecond = (second) => {
  let secondType = typeof second;

  if (secondType === 'number' || secondType === 'string') {
      second = parseInt(second);

      let hours = Math.floor(second / 3600);
      second = second - hours * 3600;
      let mimute = Math.floor(second / 60);
      second = second - mimute * 60;

      return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
      return '0:00:00'
  }
};

/**
* 格式化序号
* @param number
* @returns {string}
*/
export const numberFilter = (number) => {
  let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
  let unit = ['', '十', '百', '千', '万']
  let getNum = (temp) => {
    let strArr = temp.toString().split("").reverse();
    let newNum = "";
    for (var i = 0; i < strArr.length; i++) {
      newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
    }
    if (newNum.startsWith("一十")){
      newNum = newNum.substring(1, newNum.length);
    }
    return newNum;
  }
  return getNum(number)
}


// WEBPACK FOOTER //
// ./src/filter/index.js